import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { CONFIG } from '@frontend/config';

import {
  RecentSearch,
  loadRecents,
  persistRecents,
  pruneRecents,
  recentsFor,
  removeRecent,
  todayISO,
} from './recentSearches';

/**
 * Las búsquedas recientes DE ESTE vertical. Se guardan todas juntas (ver
 * `recentSearches.ts`) pero cada buscador muestra las suyas: en `/trenes` ver
 * búsquedas de autos es ruido.
 *
 * Se leen al montar y cuando cambia la URL: alcanza para que una búsqueda
 * recién hecha aparezca al volver, sin escuchar el storage.
 */
export function useRecentSearches(vertical: string) {
  const { search } = useLocation();
  const [all, setAll] = useState<RecentSearch[]>([]);

  useEffect(() => {
    // Se poda al leer: las que ya viajaron no se muestran ni un instante.
    setAll(pruneRecents(loadRecents(CONFIG.AGENCY_ID), todayISO()));
  }, [search]);

  const remove = useCallback((entry: RecentSearch) => {
    setAll((current) => {
      const next = removeRecent(current, entry);
      persistRecents(CONFIG.AGENCY_ID, next);
      return next;
    });
  }, []);

  return { recents: recentsFor(all, vertical), remove };
}
